import { render, staticRenderFns } from "./c_player_teacherinfo.vue?vue&type=template&id=c7cfced6&scoped=true&"
import script from "./c_player_teacherinfo.vue?vue&type=script&lang=js&"
export * from "./c_player_teacherinfo.vue?vue&type=script&lang=js&"
import style0 from "./c_player_teacherinfo.vue?vue&type=style&index=0&id=c7cfced6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cfced6",
  null
  
)

export default component.exports